<template>
  <section>
    <div class="container mt-5">
      <h1>Plasma IQ</h1>
      <p class="text-justify">Plasma IQ jest prostym i bezpiecznym urządzeniem do bezinwazyjnego liftingu powiek, drobnych zmarszczek i innych miejscowych zmian skórnych. Dzięki niewielkiemu łukowi elektrycznemu powstającemu pomiędzy końcówką urządzenia, a skórą generowane są mikrowiązki plazmy, które w kontrolowany sposób doprowadzają do sublimacji naskórka i obkurczenia się skóry. Zabieg wykonywany jest punktowo, dzięki czemu precyzyjnie oddziałuje tylko w miejscu zetknięcia ze skórą nie naruszając otaczających tkanek.</p>
      <hr class="separator" />
      <p class="text-center">Zabieg liftingu powiek przy wykorzystaniu urządzenia Plasma IQ jest:</p>
      <ul>
        <li><span class="font-weight-bold">Bezinwazyjny</span> - polecany dla osób, które nie chcą decydować się na zabieg chirurgiczny (blefaroplastykę powiek),</li>
        <li><span class="font-weight-bold">Precyzyjny</span> - mikrowiązka plazmy działa jedynie w obrębie naskórka bez uszkadzania skóry,</li>
        <li><span class="font-weight-bold">Dający natychmiastowy efekt</span> - efekty widoczne już po pierwszym zabiegu,</li>
        <li><span class="font-weight-bold">Bezpieczny</span> - bezpieczny dla osób z rozrusznikami serca oraz osób, u których zabiegi z zastosowaniem prądu nie są wskazane,</li>
        <li><span class="font-weight-bold">Komfortowy</span> - nie wymaga wyłączenia z codziennej aktywności.</li>
      </ul>
      <blockquote class="blockquote">
        <p>Plasma IQ to urządzenie, dzięki któremu możemy wykonać bezpieczny i mało inwazyjny zabieg liftingowania powiek i okolicy oczu. Efekty są spektakularne. Doskonale sprawdza się w usuwaniu zmarszczek np.: zmarszczek palacza. Jest urządzeniem bardzo precyzyjnym, dlatego też wykorzystuję je przy drobnych zabiegach dermatochirurgicznych. Zabiegi wykonywane przy użyciu urządzenia Plasma IQ są bezpieczne, mało inwazyjne a efekty widoczne są już po pierwszym zabiegu.</p>
        <footer>dr Michał Kaniowski &mdash; Specjalista dermatolog</footer>
      </blockquote>
    </div>
  </section>
</template>

<script>
export default {
  name: 'plasma',
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// Plasma.vue?6f4a87e2